import FlatButton from './FlatButton';

export default FlatButton;
